export const environment = {
  production: true,

  // // CARITAS APPLICATION PROD SERVER
  // authApiUrl: "http://172.16.5.224:6007",
  // apiUrl: "http://172.16.5.224:6008",


  

  //  CARITAS Database server
  // authApiUrl: "http://172.16.5.28:6809",
  // apiUrl: "http://172.16.5.28:6804",

  //  CARITAS UAT server
  authApiUrl:'/applicant-api',
  apiUrl:'/hr-api',
  // authApiUrl: "http://172.16.5.27:6007",
  // apiUrl: "http://172.16.5.27:6008",

  // // E&M server
  //  authApiUrl: "http://localhost:6809",
  //  apiUrl: "http://localhost:6804",

    // authApiUrl: "http://197.188.71.138:6809",
    // apiUrl: "http://197.188.71.138:6804",

};
